import type { ComponentProps } from 'react'
import type { ExtraProps } from 'react-markdown'

interface ParagraphProps extends ComponentProps<'p'>, ExtraProps {}

/**
 * A paragraph that is only an image is a figure, with the title as its caption. react-markdown
 * wraps every image in a paragraph, and a figure inside one is invalid, so the paragraph is what
 * gets replaced.
 */
function Paragraph({ node, children, ...props }: ParagraphProps) {
  const content = node?.children.filter((child) => child.type !== 'text' || child.value.trim())
  const only = content?.length === 1 ? content[0] : undefined
  if (only?.type !== 'element' || only.tagName !== 'img') return <p {...props}>{children}</p>

  const title = only.properties.title
  return (
    <figure data-md-figure>
      {children}
      {typeof title === 'string' && title && <figcaption>{title}</figcaption>}
    </figure>
  )
}

Paragraph.displayName = 'Markdown.Paragraph'

export { Paragraph }
export type { ParagraphProps }
